<!-- Error messsages -->
<mat-card
  class="validation-error"
  *ngIf="errorMessages?.length > 0"
  data-automation-id="validation-container_202126115306"
>
  <mat-list dense>
    <mat-list-item *ngFor="let msg of errorMessages">
      <mat-icon matListIcon>error</mat-icon>
      {{ msg.message || msg.code || msg.type || msg.id }}
    </mat-list-item>
  </mat-list>
</mat-card>

<!-- Warning Messages -->
<mat-card
  class="validation-warning"
  *ngIf="warningMessages?.length > 0"
  data-automation-id="validation-container_202126115312"
>
  <mat-list dense>
    <mat-list-item *ngFor="let msg of warningMessages">
      <mat-icon matListIcon>warning</mat-icon>
      {{ msg.message || msg.code || msg.type || msg.id }}
    </mat-list-item>
  </mat-list>
</mat-card>

<!-- Info Messages -->
<mat-card
  class="validation-info"
  *ngIf="infoMessages?.length > 0"
  data-automation-id="validation-container_202126115319"
>
  <mat-list dense>
    <mat-list-item *ngFor="let msg of infoMessages">
      <mat-icon matListIcon>info</mat-icon>
      {{ msg.message || msg.code || msg.type || msg.id }}
    </mat-list-item>
  </mat-list>
</mat-card>
